define('prototypes/ReCaptcha',['site_vars', 'jquery'], function (site_vars, $) {
    var reCaptchaEnable = !!parseInt(site_vars.reCaptchaEnable) || !!parseInt(site_vars.reCaptchaOrderEnable);
    if(reCaptchaEnable) {
        var d = document;
        $(d).ready(function($){
            var script = d.createElement('script');
            script.src = site_vars.reCaptcha;
            script.defer = true;
            setTimeout(function(){
                d.body.append(script);
            },1000);
        });
    }
    return function (action, callback, errorCallback) {
        if(!reCaptchaEnable){
            return callback('-');
        }
        try {
            grecaptcha.ready(function () {
                try {
                    grecaptcha.execute(site_vars.reCaptchaKey, {action: action}).then(function (token) {
                        callback(token);
                    })
                }catch (err) {
                    errorCallback(err);
                }
            })
        }catch(err){
            errorCallback(err);
        }
    }
});
